import React from 'react';
import type SignatureCanvasType from 'react-signature-canvas';
import type { SignatureField } from '../../../api/bookingApi';
import { AgreementSigFieldRenderer } from '../AgreementSigFieldRenderer';
import { SavedSignatureNote } from '../V2Bits';
import type { StagedUpload, V2Item } from '../types';

export function V2AgreementSigStep({ item, sigField, sigFieldIndex, value, onChange, sigRefs, staged }: {
  item: V2Item;
  sigField: SignatureField;
  sigFieldIndex: number;
  value: string | undefined;
  onChange: (v: string) => void;
  sigRefs: React.MutableRefObject<Map<string, SignatureCanvasType | null>>;
  staged?: StagedUpload;
}) {
  const inputId = `agsiginput-${item.instanceItemId}-${sigFieldIndex}`;
  const hasNativeInput = sigField.type !== 'signature';
  return (
    <div className="py-4">
      <span className="text-xs font-bold text-primary-deep uppercase tracking-widest">{item.name}</span>
      <label htmlFor={hasNativeInput ? inputId : undefined} className="block text-xl sm:text-2xl font-bold text-gray-900 mt-2 mb-4 sm:mb-8 leading-tight">
        {sigField.label}
        {sigField.required && <span className="text-primary-deep ml-1">*</span>}
      </label>
      <div className="min-h-[120px]">
        <AgreementSigFieldRenderer
          field={sigField}
          formId={item.instanceItemId}
          index={sigFieldIndex}
          value={value}
          onChange={onChange}
          sigRefs={sigRefs}
          variant="v2"
          inputId={inputId}
        />
        {sigField.type === 'signature' && <SavedSignatureNote staged={staged} />}
      </div>
    </div>
  );
}
